"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cleanupClassNames = cleanupClassNames;
exports.cleanupClassObject = cleanupClassObject;
exports.uniqueId = exports.overrideFocusTarget = exports.isTargetInsideContainer = exports.formatSvgBase64Src = exports.findParentWithTagName = void 0;
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var isTargetInsideContainer = function isTargetInsideContainer(target, container) {
  return target && (target.parentElement === container || isTargetInsideContainer(target.parentElement, container));
};
/** @deprecated use element.closest() instead */
exports.isTargetInsideContainer = isTargetInsideContainer;
var findParentWithTagName = function findParentWithTagName(child, tagName) {
  if (!child.parentElement) {
    return false;
  }
  return child.parentElement.tagName === tagName.toUpperCase() ? child.parentElement : findParentWithTagName(child.parentElement, tagName);
};
/** @deprecated this can be done inline */
exports.findParentWithTagName = findParentWithTagName;
var overrideFocusTarget = function overrideFocusTarget(calledOnElm, focusTarget) {
  return calledOnElm.focus = function () {
    return focusTarget.focus();
  };
};
exports.overrideFocusTarget = overrideFocusTarget;
var formatSvgBase64Src = function formatSvgBase64Src(svgString) {
  if (typeof btoa !== "undefined") {
    return "data:image/svg+xml;base64,".concat(btoa(svgString));
  }
  if (typeof global !== "undefined" && typeof Buffer !== "undefined") {
    return "data:image/svg+xml;base64,".concat(Buffer.from(svgString, "binary").toString("base64"));
  }
};
exports.formatSvgBase64Src = formatSvgBase64Src;
function cleanupClassNames(classNames) {
  var result = classNames.filter(function (elm) {
    return !!elm;
  }).join(" ");
  return result ? result : undefined;
}
function cleanupClassObject(classObject) {
  return Object.entries(classObject).reduce(function (acc, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      cssClass = _ref2[0],
      isActive = _ref2[1];
    return isActive ? "".concat(acc).concat(cssClass, " ") : acc;
  }, "");
}
var time = Date.now();
var getTime = function getTime() {
  time = Math.max(time + 1, Date.now());
  return time;
};
var uniqueId = function uniqueId() {
  var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  return prefix + getTime().toString(36);
};
exports.uniqueId = uniqueId;